import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { discardSeedProject, listSeedProjects, publishSeedProject } from '@/api/admin'

const KEY = ['admin', 'seed-projects'] as const

export const useSeedProjects = () =>
  useQuery({
    queryKey: KEY,
    queryFn: () => listSeedProjects(),
    retry: (failureCount, error) => {
      const status = (error as { status?: number })?.status
      if (status === 403 || status === 401) return false
      return failureCount < 3
    },
  })

export const usePublishSeedProject = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => publishSeedProject(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  })
}

export const useDiscardSeedProject = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => discardSeedProject(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  })
}
